import React, { Component } from 'react'

class Screen8A extends Component {

  state = {}

  yes = () => {
    this.props.addEntry('name', undefined, null)
    this.props.addEntry('email', undefined, null)
    this.setState({consent: true})
  }

  cancel = () => {
    this.props.addEntry('name','', null)
    this.props.addEntry('email','', null)
    this.setState({consent: false})
  }

  render() {

    const { entry, addEntry, language, t } = this.props

    return (
      <main>
        <h3>{t(language, 'hateCrimeDetails')}</h3>

        <label>{language === 'hr' ? 'U slučaju potrebe za više detalja o prijavi, možemo li vas kontaktirati?' : 'In case we need more details about your report, can we contact you?'}</label>
        <button className="square orange" onClick={this.yes}>{language === 'hr' ? 'DA' : 'YES'}</button>
        <button className="square" onClick={this.cancel}>{language === 'hr' ? 'NE' : 'NO'}</button>

        { this.state.consent === true &&
          <div>
            <label>{language === 'hr' ? 'Ime' : 'Name'}
              <input type="text" value={entry.name} onChange={(e) => addEntry('name', null, e)} />
            </label>
            <label>Email
              <input type="text" value={entry.email} onChange={(e) => addEntry('email', null, e)} />
            </label>
            <p style={{fontSize: 13}}>
              <strong>{language === 'hr' ? 'Pristanak za pohranu i obradu osobnih podataka' : 'Consent for storage and processing of personal data'}</strong>
              <br />
              {language === 'hr' ? 'Brinemo o vašim osobnim podacima. Naše politika zaštite osobnih podataka usklađene su s odredbama Opće uredbe o zaštiti podataka (General Data Protection Regulation – GDPR, 95/46/EC). Svi osobni podaci prikupljaju se isključivo za potrebe postupanja po ovoj prijavi i neće biti korišteni za druge svrhe, niti dijeljeni s trećim stranama. Više informacija o osobnim podacima možete pronaći ovdje:' : 'We care about your personal data. Our personal data protection policies comply with the provisions of the General Data Protection Regulation (GDPR, 95/46/EC). All personal data is collected exclusively for the purposes of processing this report and will not be used for other purposes or shared with third parties. More information about personal data can be found here:'} <a style={{color: 'black'}} href="https://bit.ly/36okD2t" rel="noopener noreferrer" target="_blank">https://bit.ly/36okD2t</a>.
            </p>
          </div>
        }
        { this.state.consent === false &&
        <div>
          <p>{language === 'hr' ? 'Budući da ne želite ostaviti kontakt, Vaša prijava bit će spremljena u našu bazu i služit će nam isključivo za statističku svrhu.' : 'Since you do not want to leave your contact information, your report will be saved in our database and will serve us exclusively for statistical purposes.'}</p>
        </div>
        }
      </main>
    );
  }
}

export default Screen8A;
